module.exports = __webpack_public_path__ + "img/wptrs.d05d28c6.png";